(function() {
  function openModal(root, modal) {
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    root.dataset.modalOpen = 'true';
  }

  function closeModal(root, modal) {
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    root.dataset.modalOpen = 'false';
  }

  function showPanel(container, type) {
    var panels = container.querySelectorAll('[data-scp-bonus-panel]');
    panels.forEach(function(panel) {
      panel.hidden = panel.getAttribute('data-scp-bonus-panel') !== type;
    });
  }

  function resetSocialState(container) {
    var couponWrap = container.querySelector('[data-scp-coupon-wrap]');
    var copyButton = container.querySelector('[data-scp-copy-button]');
    if (couponWrap) couponWrap.hidden = true;
    if (copyButton) {
      copyButton.textContent = copyButton.dataset.copyLabel || 'Kodu Kopyala';
    }
  }

  function handleCopy(button, codeText) {
    if (!button || !codeText) return;

    var copiedLabel = button.dataset.copiedLabel || 'Kopyalandi!';
    var copyLabel = button.dataset.copyLabel || 'Kodu Kopyala';

    function onSuccess() {
      button.textContent = copiedLabel;
      window.setTimeout(function() {
        button.textContent = copyLabel;
      }, 1600);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(codeText).then(onSuccess).catch(function() {
        button.textContent = copyLabel;
      });
      return;
    }

    var tempInput = document.createElement('textarea');
    tempInput.value = codeText;
    tempInput.setAttribute('readonly', '');
    tempInput.style.position = 'absolute';
    tempInput.style.left = '-9999px';
    document.body.appendChild(tempInput);
    tempInput.select();

    try {
      document.execCommand('copy');
      onSuccess();
    } catch (error) {
      button.textContent = copyLabel;
    }

    document.body.removeChild(tempInput);
  }

  function initBonusCards(scope) {
    var roots = (scope || document).querySelectorAll('[data-scp-bonus-root]');
    roots.forEach(function(root) {
      if (root.dataset.scpBonusReady === 'true') return;
      root.dataset.scpBonusReady = 'true';

      var modal = root.querySelector('[data-scp-bonus-modal]');
      if (!modal) return;

      // Fixed overlay'in viewport'a gore calismasi icin modal'i body altina tasiyoruz.
      if (modal.dataset.scpMovedToBody !== 'true') {
        document.body.appendChild(modal);
        modal.dataset.scpMovedToBody = 'true';
      }

      var triggers = root.querySelectorAll('[data-scp-bonus-trigger]');
      var closes = modal.querySelectorAll('[data-scp-bonus-close]');
      var followButton = modal.querySelector('[data-scp-bonus-follow]');
      var couponWrap = modal.querySelector('[data-scp-coupon-wrap]');
      var couponCode = modal.querySelector('[data-scp-coupon-code]');
      var copyButton = modal.querySelector('[data-scp-copy-button]');

      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var type = trigger.getAttribute('data-popup-type');
          showPanel(modal, type);
          if (type === 'social') resetSocialState(modal);
          openModal(root, modal);
        });
      });

      closes.forEach(function(closeButton) {
        closeButton.addEventListener('click', function() {
          closeModal(root, modal);
        });
      });

      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && root.dataset.modalOpen === 'true') {
          closeModal(root, modal);
        }
      });

      if (followButton && couponWrap) {
        followButton.addEventListener('click', function() {
          couponWrap.hidden = false;
        });
      }

      if (copyButton && couponCode) {
        copyButton.addEventListener('click', function() {
          handleCopy(copyButton, couponCode.textContent.trim());
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initBonusCards(document);
    });
  } else {
    initBonusCards(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initBonusCards(event.target);
  });
})();
